/**
 * A /rate pick, in the shape PlayerAvatar reads.
 *
 * Its own module because BOTH reports' rows draw faces, and the shared
 * GroupCard cannot import it from TeamReportView without a cycle: that file
 * imports GroupCard. TeamReportView re-exports it, so every existing caller
 * and every test keeps its import path.
 */
export function avatarPlayer(pick) {
  if (!pick) return null;
  return { name: pick.player, pos: pick.pos, team: pick.team, sleeper_id: pick.sleeperId };
}
